import Form         from '../../../Lib/Forms/Form';
import AuthResource from "../ApiResources/AuthResource";

export default class ForgotPasswordForm extends Form {

    constructor(email = '') {
        super();
        this.email = email;
    }

    rules() {
        return {
            email: ['required', 'email'],
        }
    }

    submit() {
        return new AuthResource()
            .forgotPassword({ email: this.email }).then();
    }

}
